import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { getLocalStorage } from 'src/hooks/useLocalStorage';

const LoadUser: React.FC = () => {
    const userToken = getLocalStorage('jwt-token');

    useEffect(() => {
        if (!userToken) {
            console.log('이동');
            // history.push('/login');
        }
    }, [userToken]);

    return userToken ? null : <div />;
};

export default LoadUser;
